module.exports = __webpack_public_path__ + "static/img/wealth_level_99.d2996f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/level/wealth_level_99.png
// module id = 1W3q
// module chunks = 0